import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "dollar, currency, money, coin, USD" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M10.6663 6.14567V5.28919M10.6663 13.854V14.7105M12.5211 7.43039C12.1509 6.91839 11.4589 6.57391 10.6663 6.57391H10.4284C9.37727 6.57391 8.52514 7.25562 8.52514 8.09655V8.16192C8.52514 8.76341 8.94993 9.31327 9.62242 9.58227L11.7103 10.4174C12.3827 10.6864 12.8075 11.2363 12.8075 11.8378C12.8075 12.7148 11.9188 13.4258 10.8225 13.4258H10.6663C9.87379 13.4258 9.18182 13.0813 8.81159 12.5693M18.3747 9.99984C18.3747 14.257 14.9235 17.7082 10.6663 17.7082C6.40915 17.7082 2.95801 14.257 2.95801 9.99984C2.95801 5.74264 6.40915 2.2915 10.6663 2.2915C14.9235 2.2915 18.3747 5.74264 18.3747 9.99984Z",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }